import {Box, Typography} from '@mui/material';
import '../../pages/GrowthHackTableData/GrowthHackTableData.scss';

export default function DescriptionCard({ GrowthHackSummaryGenAI }) {
    const rawText = GrowthHackSummaryGenAI?.trim();
    const hasContent = Boolean(rawText);

    const bulletItems = hasContent
        ? rawText.split(/##\s*/).map(s => s.trim()).filter(s => s.length > 0)
        : [];

    const isBulletFormat = bulletItems.length > 1;

    return (
        <Box className="info-card-content custom-card">
            <Typography variant="h6" className="card-title">
                Growth Hack Description
            </Typography>
            {hasContent ? (
                isBulletFormat ? (
                    <ul className="description-card-list">
                        {bulletItems.map((item, idx) => (
                            <li key={idx}>
                                <Typography className="description-card-text" component="span">
                                    {item}
                                </Typography>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <Typography className="description-card-text">
                        {rawText}
                    </Typography>
                )
            ) : (
                <Typography className="description-card-text">
                    Description Not available
                </Typography>
            )}
        </Box>
    );
}
